import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Zap } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";

export function BreakingBar() {
  const { t, title } = useI18n();
  const { data } = useQuery({
    queryKey: ["breaking"],
    queryFn: async () => (await api.get("/live?limit=6&diverse=true")).data,
    refetchInterval: 60000,
  });

  const items = data?.items || [];
  if (items.length === 0) return null;

  // duplicate for a seamless loop
  const loop = [...items, ...items];

  return (
    <div
      data-testid="breaking-bar"
      className="fixed top-0 inset-x-0 z-[60] h-9 flex items-stretch overflow-hidden bg-[#0b0d13] text-white border-b border-white/10"
    >
      <div className="shrink-0 flex items-center gap-1.5 px-3 bg-red-600 font-mono text-[11px] font-bold uppercase tracking-wider">
        <span className="live-ring w-1.5 h-1.5 rounded-full bg-white" />
        <Zap size={12} className="fill-white" />
        <span data-testid="breaking-label">{t("breaking.label")}</span>
      </div>
      <div className="relative flex-1 overflow-hidden flex items-center">
        <div className="breaking-marquee items-center">
          {loop.map((a, i) => (
            <Link
              key={`${a.id}-${i}`}
              to={`/article/${a.id}`}
              className="inline-flex items-center text-[13px] text-slate-200 hover:text-white transition-colors"
            >
              <span className="mx-3 text-red-500">◆</span>
              <span className="font-medium">{title(a)}</span>
              <span className="ms-2 text-[11px] text-slate-400">— {a.source_name}</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
